export const PROVIDER_NO_CONNECTED = 1;
export const PROVIDER_CONNECTED = 2;
export const PROVIDER_PENDING = 3;
export const PROVIDER_PENDING_DISCONNECT = 4;

export const PROVIDER_STATE_ACTIVE = 1;
export const PROVIDER_STATE_INACTIVE = 2;
export const PROVIDER_STATE_PENDING = 3;
export const PROVIDER_STATE_PENDING_INACTIVE = 4;

export const PROVIDER_NOT_CONFIRM_ORDER = 1;
export const PROVIDER_AUTO_CONFIRM_ORDER = 2;

export const getProviderStatus = (status) => {
  switch (status) {
    case PROVIDER_CONNECTED:
      return 'Connected';
    case PROVIDER_NO_CONNECTED:
      return 'Not connected';
    case PROVIDER_PENDING:
      return 'Connecting';
    case PROVIDER_PENDING_DISCONNECT:
      return 'Disconnecting';
    default:
      return null;
  }
};

export const getProviderState = (status) => {
  switch (status) {
    case PROVIDER_STATE_ACTIVE:
      return 'Active';
    case PROVIDER_STATE_INACTIVE:
      return 'Inactive';
    case PROVIDER_STATE_PENDING:
      return 'Activating';
    case PROVIDER_STATE_PENDING_INACTIVE:
      return 'Deactivating';
    default:
      return null;
  }
};
export const getProviderConfirmOrder = (status) => {
  switch (status) {
    case PROVIDER_AUTO_CONFIRM_ORDER:
      return 'Auto Confirm Orders';
    case PROVIDER_NOT_CONFIRM_ORDER:
      return 'Auto Confirm Orders';
    default:
      return null;
  }
};
